module.exports = __webpack_public_path__ + "img/mc_sc.197e7637.svg";